import script from "./AvatarImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarImage.vue?vue&type=script&setup=true&lang=js"

import "./AvatarImage.vue?vue&type=style&index=0&id=72f7a93a&lang=scss"

const __exports__ = script;

export default __exports__